const isMaxUser = userType => userType === "MAX_USER";

export default isMaxUser;
